import { createContext, useContext } from 'react'
import { RmnPublicBrand, ResolvedRmnPalette } from '../../types/rmn'
import { resolveRmnPalette } from '../../utils/color'

export interface RmnBrandContextValue {
  brand: RmnPublicBrand | null
  palette: ResolvedRmnPalette
  loading: boolean
}

export const RmnBrandContext = createContext<RmnBrandContextValue>({
  brand: null,
  palette: resolveRmnPalette(null),
  loading: true,
})

export const useRmnBrand = () => useContext(RmnBrandContext)
